import Reveal from "./Reveal";

const WAYS = [
  {
    no: "01",
    title: "按人物 · 纵着看",
    text: "把同一个人的旧账新料拉成一条时间线，从出道到如今一次对完，适合要补全某人完整前史的人。",
    icon: "ri-user-follow-line",
    href: "#people",
    hint: "跳去人物时间线",
  },
  {
    no: "02",
    title: "按事件 · 横着看",
    text: "同类事件跨人物打包，选秀、带货、感情、税务……想看某个题材翻车全集就进对应合集。",
    icon: "ri-stack-line",
    href: "#comp",
    hint: "跳去事件合集",
  },
  {
    no: "03",
    title: "按年份 · 按编年翻",
    text: "把全年热点压成一条年轴，按 2021—2026 逐年点开，适合想按时间大势回看的人。",
    icon: "ri-calendar-check-line",
    href: "#year",
    hint: "跳去按年总览",
  },
];

export default function GuideStrip() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <div className="mb-7 flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              新瓜友 · 从这三处开翻
            </p>
            <h4 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              档案很大，别迷路，选一条线先走
            </h4>
          </div>
          <p className="max-w-sm text-xs leading-6 text-foreground-500 md:text-sm">
            三条浏览视角对应三套目录结构，想补旧料还是追新瓜，入口都不一样。
          </p>
        </div>
      </Reveal>

      <div className="grid gap-4 md:grid-cols-3 md:gap-5">
        {WAYS.map((w, i) => (
          <Reveal key={w.no} delay={i * 90}>
            <a
              href={w.href}
              className="group flex h-full flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-6"
            >
              <div className="flex items-start justify-between">
                <span className="font-heading text-4xl font-black leading-none text-background-300 group-hover:text-primary-300">
                  {w.no}
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                  <i className={`${w.icon} text-lg leading-none`}></i>
                </span>
              </div>
              <h5 className="mt-5 font-heading text-lg font-bold text-foreground-950">{w.title}</h5>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{w.text}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                {w.hint}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}